import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

export interface RequestErrorSnackData {
  title: string;
  detail: string;
}

@Component({
  selector: 'lib-request-error-snack',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './request-error-snack.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestErrorSnackComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) protected readonly data: RequestErrorSnackData,
    protected readonly snackBarRef: MatSnackBarRef<RequestErrorSnackComponent>,
  ) {}
}
